import { PropsWithChildren } from 'react';

import { AlertProps, Typography } from '@mui/material';

import { StyledAlert } from './Ribbon.styled';

type Props = { onClose(): void } & Pick<AlertProps, 'sx'>;

export const Ribbon = ({ sx, children, onClose }: PropsWithChildren<Props>) => (
  <StyledAlert onClose={onClose} sx={sx}>
    <Typography variant="inherit" component="span">
      {children}
    </Typography>
  </StyledAlert>
);
